import { useEffect, useState } from "react";

import {
  DocumentList,
  ExpandablePanel,
  ExpandablePanelBody,
  ExpandablePanelHeader,
  Typography,
} from "@king-ict/eupisi-ui/components";
import { useTranslation } from "react-i18next";

import {
  getGroupList,
  searchItem,
  getFaqDocumentById,
} from "../../api/Faq/FaqApi";
import { FormCard, ToolbarTop } from "../../components";
import { ContentArea } from "../../components/ContentArea";
import { Group, ItemSearch, Item } from "../../models/Faq";
import { Attachment } from "../../models/Shared/Attachment";

export function Faq() {
  const { t } = useTranslation();

  const [groups, setGroups] = useState<Group[]>();
  const [items, setItems] = useState<Item[]>([]);

  useEffect(() => {
    (async () => {
      var search: ItemSearch = {
        onlyStatus: true,
        pageSize: 100,
      };
      var groupPromise = getGroupList();
      var itemPromise = searchItem(search);

      var groupList = await groupPromise;
      if (groupList !== null)
        setGroups(
          groupList.filter(
            (group) =>
              (group.faqApplicationDisplayId === 2 ||
                group.faqApplicationDisplayId === 3) &&
              group.status
          )
        );
      var itemList = await itemPromise;
      if (itemList !== null) setItems(itemList.results);
    })();
  }, []);

  const getGroups = () => {
    console.log(groups);
    if (groups && groups.length > 0) {
      return groups.map((group, index) => (
        <div key={index}>
          {items.some((item) => item.group?.id === group.id) && (
            <FormCard>
              <ExpandablePanel clickableHeader={true}>
                <ExpandablePanelHeader>
                  <Typography color="primary">{group.name}</Typography>
                </ExpandablePanelHeader>
                <ExpandablePanelBody>
                  {getGroupAccordian(group.id)}
                </ExpandablePanelBody>
              </ExpandablePanel>
            </FormCard>
          )}
        </div>
      ));
    }
  };

  const getGroupAccordian = (id: number) => {
    if (!items || !items.find((item) => item.group?.id === id)) return null;

    var thisGroupItems = items.filter((item) => item.group?.id === id);

    return (
      <>
        {thisGroupItems.map((item, index) => (
          <div key={index}>
            <ExpandablePanel clickableHeader={true}>
              <ExpandablePanelHeader>
                <Typography color="light">{item.question}</Typography>
              </ExpandablePanelHeader>
              <ExpandablePanelBody>
                <div
                  dangerouslySetInnerHTML={{ __html: item.answer || "" }}
                  className="ml-5"
                ></div>
                {item.attachments && item.attachments.length > 0 && (
                  <DocumentList
                    documents={item.attachments}
                    removable={false}
                    onDocumentClick={handleGetDocument}
                  />
                )}
              </ExpandablePanelBody>
            </ExpandablePanel>
          </div>
        ))}
      </>
    );
  };

  const getAttachmentList = (attachments: Attachment[]) => {
    if (!attachments || !(attachments.length > 0)) return null;

    return attachments.map((attachment) => <p>{attachment.fileName}</p>);
  };

  const handleGetDocument = (doc: Attachment) => {
    if (doc && doc.id) {
      getFaqDocumentById(doc.id);
    }
  };

  return (
    <ContentArea>
      <ToolbarTop pageTitle={t("navigation.faq")}></ToolbarTop>
      <FormCard>{getGroups()}</FormCard>
    </ContentArea>
  );
}
